module.exports = __webpack_public_path__ + "img/img_mall@2x.663c4200.png";